import { HomeIconComponent } from '@shared/icons/home-icon.component';

export interface MenuItem {
  label: string;
  path: string;
  icon: any; // or Type<any>
}

export const MENU_ITEMS: MenuItem[] = [
  {
    label: 'Home',
    path: '/',
    icon: HomeIconComponent
  }
];